/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Component } from '@angular/core';
import { IMemberAspectItem } from './interfaces/IMemberAspectItem';
import { BehaviorSubject } from 'rxjs';

// ugh, the types are all made up in this garbage
export interface IMemberAspectItemButReality extends MemberAspectItemBase {
	timeoutError$: BehaviorSubject<object>;
	dashboardFrameError$: BehaviorSubject<object>;
}

// base component for the member aspect item shown on the right side
@Component({
	selector: 'app-aspect-item',
	template: ``,
})
export class MemberAspectItemBase {
	// the model of this aspect item
	protected aspectItem: IMemberAspectItem;
	// If there will be some loading time for this aspect item to be ready for display
	// we can use contentready to signal that. the default is true
	protected _contentReady$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
	public contentReady$ = this._contentReady$.asObservable();
	// If there will be nested content in this aspect item that replaces the display of
	// the top content, we can use inNestedContent to signal that. the default is false
	protected _inNestedContent$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	public inNestedContent$ = this._inNestedContent$.asObservable();

	constructor() {}

	public setAspectItem(aspectItem: IMemberAspectItem) {
		this.aspectItem = aspectItem;
	}

	public setContentReady(ready: boolean) {
		this._contentReady$.next(ready);
	}

	public setInNestedContent(ready: boolean) {
		this._inNestedContent$.next(ready);
	}

	public gotoRootContent() {
		this.setInNestedContent(false);
	}
}
